module.exports = __webpack_public_path__ + "img/soundEffect-record.9f049d37.png";